import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Descriptions,
  Modal,
  Row,
  Space,
  Table,
} from "antd";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import DashboardContext from "Context";
import Excel from "components/table/excel";
import InputDate from "components/inputs/InputDate";
import InputControl from "components/inputs/InputControl";
import CustomPagination from "components/table/pagination";
import toaster from "helper/toaster";

export default function WorkCancelReport() {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [formData, setFormData] = useState({});
  const [record, setRecord] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    getWorkCancelReport({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getWorkCancelReport = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = "/workCancelReport/get";
      const res = await axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          ...formData,
        }),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getWorkCancelReport({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const search = () => {
    getWorkCancelReport({
      page: 1,
      pageSize: 10,
    });
  };

  const onSelectChange = (rowId) => {
    markAsRead(rowId);
  };

  const markAsRead = async (rowId) => {
    setLoading(true);
    try {
      const res = await axios.put(
        `${urldashboard}/workCancelReport/setSeen/${rowId}`,
        {},
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );
      const data = res?.data;
      toaster.success(data.message);
      setLoading(false);
      getWorkCancelReport({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
      });
    } catch (error) {
      setLoading(false);
      handelerrors(error);
    }
  };

  const columns = [
    {
      title: "ردیف",
      dataIndex: "index",
      key: "index",
      responsive: ["xl", "lg"],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: "خوانده شده",
      dataIndex: "isSeen",
      key: "isSeen",
      responsive: ["xl", "lg", "md", "sm", "xs"],
      render: (value, record) => (
        <>
          <Checkbox
            checked={value}
            disabled={value}
            onChange={() => onSelectChange(record?.id)}
          />
        </>
      ),
    },
    {
      title: "نام شرکت",
      dataIndex: "companyName",
      key: "companyName",
      responsive: ["xl", "lg", "md"],
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "آدرس مشتری",
      dataIndex: "customerAddress",
      key: "customerAddress",
      responsive: ["xl", "lg"],
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "زمان شروع کار",
      dataIndex: "persianStartWork",
      key: "persianStartWork",
      responsive: ["xl", "lg"],
      render: (value) => <span>{value ? value : "-"}</span>,
    },
    {
      title: "نام نیرو",
      dataIndex: "workerName",
      key: "workerName",
      responsive: ["xl", "lg", "md", "sm", "xs"],
      render: (value, record) => (
        <Space direction='vertical'>
          {value ?? "-"}
          {record?.workerPhoneNumber ?? "-"}
        </Space>
      ),
    },
    {
      title: "زمان لغو",
      dataIndex: "persianActionDateTime",
      key: "persianActionDateTime",
      responsive: ["xl", "lg"],
      render: (value) => <span>{value ? value?.replace(" ", "\n") : "-"}</span>,
    },
    {
      title: "حالت لغو",
      dataIndex: "cancelTitle",
      key: "cancelTitle",
      responsive: ["xl", "lg", "md", "sm"],
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "دلیل لغو",
      dataIndex: "jobDispatchReasonTitle",
      key: "jobDispatchReasonTitle",
      responsive: ["xl", "lg", "md", "sm"],
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: "توضیحات لغو",
      dataIndex: "jobDispatchActionDescription",
      key: "jobDispatchActionDescription",
      responsive: ["xl", "lg", "md"],
      render: (value) => <span>{value ? value : "-"}</span>,
    },
    {
      title: "مقدار جریمه (ریال)",
      dataIndex: "penaltyAmount",
      key: "penaltyAmount",
      responsive: ["xl", "lg", "md", "sm", "xs"],
      render: (value) => (
        <span style={{ color: "crimson" }}>
          {value ? value.toLocaleString() : "-"}
        </span>
      ),
    },
    {
      title: "اطلاعات بیشتر",
      dataIndex: "index",
      key: "index",
      responsive: ["xl", "lg", "md", "sm", "xs"],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  const showInfoModal = async (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={["0"]}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row gutter={20}>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/businessCompany/getDropdown'
                    label='شرکت'
                    name='companyId'
                    handelValue={(_, value) => {
                      if (value) {
                        setFormData({ ...formData, companyId: value });
                      } else {
                        setFormData({
                          ...formData,
                          companyId: null,
                        });
                      }
                    }}
                  />
                </Col>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputDate
                    label='تاریخ شروع کار از'
                    name='fromDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, fromDate: value })
                    }
                  />
                </Col>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputDate
                    label='تاریخ پایان کار تا'
                    name='toDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, toDate: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row
                gutter={20}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <Col xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Button
                    type='primary'
                    style={{ width: "100%" }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>
      <Row
        gutter={20}
        style={{
          marginTop: 25,
          alignItems: "center",
        }}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ marginBottom: 20 }}
        >
          <Space
            wrap
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Excel
              server
              fileName={"گزارش_لغو_کار_نیروها"}
              url={"/workCancelReport/getexcel"}
              props={{
                page: pagination?.page,
                pageSize: pagination?.pageSize,
                ...formData,
              }}
            />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: "right", marginTop: 10 }}
        rowClassName={() => "center"}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: "موردی یافت نشد",
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
          notMain
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => {
          setMoreInfoModal(false);
          setRecord({});
        }}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: "auto" }}
      >
        <Descriptions bordered column={1} size={"small"}>
          <Descriptions.Item label='نام شرکت'>
            {record?.companyName ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='آدرس مشتری'>
            {record?.customerAddress ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='زمان شروع کار'>
            {record?.persianStartWork
              ? record?.persianStartWork
              : "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='نام نیرو'>
            {record?.workerName ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='کد پیگیری سفارش'>
            {record?.trackingCode ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='شماره نیرو'>
            {record?.workerPhoneNumber ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='نوع اقدام'>
            {record?.jobDispatchReasonTypeTitle ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='زمان لغو'>
            {record?.persianActionDateTime
              ? record?.persianActionDateTime?.replace(" ", "\n")
              : "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='حالت لغو'>
            {record?.cancelTitle ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='دلیل لغو'>
            {record?.jobDispatchReasonTitle ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='نام لغوکننده'>
            {record?.cancelerName ?? "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='توضیحات لغو'>
            {record?.jobDispatchActionDescription
              ? record?.jobDispatchActionDescription
              : "اطلاعات وارد نشده"}
          </Descriptions.Item>
          <Descriptions.Item label='مقدار جریمه (ریال)'>
            {record?.penaltyAmount
              ? record?.penaltyAmount?.toLocaleString()
              : "اطلاعات وارد نشده"}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
}
